
<!-- <div mat-dialog-content>
  <p>What's your favorite animal?</p>
  <mat-form-field appearance="fill">
    <mat-label>Favorite Animal</mat-label>
    <input matInput >
  </mat-form-field>
</div> -->
<div mat-dialog-actions>
    <div>Are you sure you want to logout </div>
    <div class="d-flex justify-content-end" style="margin-top: 10px;"> 
        <button mat-button (click)="onNoClick()" >No</button>
        <button mat-button (click)="logout()" >Yes</button>
    </div>
  
</div>
<style>
    ::ng-deep.mat-dialog-actions {
        padding: 0px !important;
        display: grid !important;
    } 
</style>